import { Carousel } from '@mantine/carousel';
import { useQuery } from "@tanstack/react-query";
import { getPeopleOfInterest } from "../../../services/SearchService";
import { useApp } from "../../../context/AppContext";
import { UserCard, UserCardSkeletonLoader } from "./userCard/UserCard";


export const ProfessionalCarousel = () => {

    const {token} = useApp();

    const { data: peopleOfInterest, isLoading: loadingPeopleOfInterest } = useQuery({
        queryKey: ['peopleOfInterest'],
        queryFn: () => getPeopleOfInterest(token ?? ''),
        enabled: !!token,
    });

    const filteredPeopleOfInterest = peopleOfInterest?.filter(
        ({ headline, headerBio }) => Boolean(headline?.trim()) && Boolean(headerBio?.trim())
    );

    return (
          <Carousel
            data-testid={ProfessionalCarouselTestIds.CAROUSEL}
            slideSize="350px"
            height={200}
            slideGap="md"
            controlsOffset="sm"
            controlSize={38}
            withControls
            withIndicators={false}
            emblaOptions={{
                loop: true,
                dragFree: false,
                align: 'center'
            }}
            >
                {
                    loadingPeopleOfInterest && Array.from({ length:6 }).map((_, index) => (
                        <Carousel.Slide key={index}>
                            <UserCardSkeletonLoader />
                        </Carousel.Slide>
                    ))
                }
                {
                    !loadingPeopleOfInterest && filteredPeopleOfInterest?.map((userDocument) => (
                        <Carousel.Slide key={userDocument.id} data-testid={ProfessionalCarouselTestIds.CAROUSEL_ITEM}>
                            <UserCard userDocument={userDocument} />
                        </Carousel.Slide>
                    ))
                }
            </Carousel>
    )

};




export enum ProfessionalCarouselTestIds {
    CAROUSEL = 'professional-carousel',
    CAROUSEL_ITEM = 'professional-carousel-item',
}
